export default __webpack_public_path__ + "static/media/smileFace.76f010fc.svg";